import {Injectable}                     from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot,
	RouterStateSnapshot}                from '@angular/router';

import {Permissions}                    from "../permissions/permissions";
import {User}                           from "../user/user";

import {Observable}                     from 'rxjs/Observable';

@Injectable()
export class SuperUserGuard implements CanActivate {
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		// Retrieve the current user and check to see if they are a super user.
		let userString:string = sessionStorage.getItem('currentUser');

		// Make sure there is a proper value.
		if (null === userString) {
			return false;
		}

		let user:User = new User(JSON.parse(userString));
		let allowed:boolean = 0 !== (user.permissions & Permissions.SUPER_USER);

		if (! allowed) {

			window.alert('Contact your administrator if you need access to this menu.');

		}

		return allowed;

	}
}



// WEBPACK FOOTER //
// ./src/app/services/miscellaneous/super-user.guard.ts